export const cacheValue = <T>(make: () => T) => {
    let value: T | undefined = undefined
    return (): T => {
        if (value === undefined) value = make()
        return value
    }
}
